import type { NodeMock, StatePreset } from "../mock-types";

export const teamVoiceSplitMock: NodeMock = {
  label: "Team Voice Split",
  description: "Players move to their team voice channels",
  state: (players, teamCount) => {
    const perTeam = Math.ceil(players.length / teamCount);
    const teamChannels = Array.from({ length: teamCount }, (_, t) => ({
      teamIndex: t,
      channelId: `vc_team${t}`,
      channelName: `Team ${String.fromCharCode(65 + t)}`,
      players: players
        .filter((_, i) => Math.min(Math.floor(i / perTeam), teamCount - 1) === t)
        .map((p) => p.userId),
    }));
    // First player on each team is moved, rest are in progress
    const movedPlayers = teamChannels.map((tc) => tc.players[0]).filter(Boolean);
    return {
      teamChannels,
      spectatorChannel: null,
      movedPlayers,
      failedPlayers: [],
      noDiscord: false,
    };
  },
  config: {
    timeoutSeconds: 30,
    teamChannelNames: ["Team 1", "Team 2"],
    autoMove: true,
    labels: {
      title: "Team Voice Split",
      subtitle: "Moving players to team channels",
    },
  },
};

export const teamVoiceSplitPresets: StatePreset[] = [
  {
    label: "None Moved",
    build: ({ defaultState }) => ({
      state: { ...defaultState, movedPlayers: [], failedPlayers: [] },
    }),
  },
  {
    label: "In Progress",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        movedPlayers: players.slice(0, Math.ceil(players.length / 2)).map((p) => p.userId),
        failedPlayers: [],
      },
    }),
  },
  {
    label: "All Moved",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, movedPlayers: players.map((p) => p.userId), failedPlayers: [] },
    }),
  },
];
